var CountryModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.CountryId = ko.observable();
    that.ISO = ko.observable();
    that.Name = ko.observable();

    //functions
    that.PopulateCountryModel = function (countryData) {
        that.CountryId(countryData.CountryId);
        that.ISO(countryData.ISO);
        that.Name(countryData.ResourceName.Text);

        return that;
    };
};